import { render, staticRenderFns } from "./valuationbefore.vue?vue&type=template&id=89a5c71c&scoped=true"
import script from "./valuationbefore.vue?vue&type=script&lang=js"
export * from "./valuationbefore.vue?vue&type=script&lang=js"
import style0 from "./valuationbefore.vue?vue&type=style&index=0&id=89a5c71c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89a5c71c",
  null
  
)

export default component.exports